function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import StateData from './State.context';
import PageBackButton from '../../common/page/PageBackButton.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import PageComponentAdd from './PageComponentAdd.modal';
import FullImageComponent from './FullImageComponent.react';
import ParagraphComponent from './ParagraphComponent.react';
var PpcPage = function PpcPage() {
  var _useParams = useParams(),
    pageID = _useParams.pageID;
  var dispatch = useDispatch();
  var page = useSelector(function (s) {
    return s.ppc.page.details;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.page,
      payload: {
        formData: {
          pageID: pageID
        },
        route: 'details'
      }
    });
  }, [pageID]);
  useEffect(function () {
    if (page[pageID]) setState(page[pageID]);
  }, [pageID, page]);
  var pageComponents = state.pageComponents;
  return /*#__PURE__*/React.createElement(StateData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Section Details",
    button: {
      label: 'Add Component',
      type: 'add',
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(PageComponentAdd, {
              pageID: pageID
            })
          }
        });
      }
    }
  })), pageComponents === null || pageComponents === void 0 ? void 0 : pageComponents.map(function (x) {
    if (x.componentType === 'full-image') return /*#__PURE__*/React.createElement(FullImageComponent, _extends({}, x, {
      pageID: pageID,
      key: x._id
    }));
    if (x.componentType === 'paragraph') return /*#__PURE__*/React.createElement(ParagraphComponent, _extends({}, x, {
      pageID: pageID,
      key: x._id
    }));
    return null;
  })));
};
export default PpcPage;